import React, { Component } from 'react';
import Switcher from './Switcher';
import axios from '../../../../axios/axios';
import { setActiveLangAction } from '../../../../actions/setActiveLangAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

class LangSwitchers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            languages: [],
            showLangContainer: false,
        }

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        axios.get(`api/welsend/public/languages`)
            .then(res => res.data)
            .then(languages => {
                const langsActive = languages.filter(lang => lang.active === true);
                this.setState({languages: langsActive})
            })
            .catch((error =>  {
                console.log(error);
            }))

        document.addEventListener('mouseup', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({showLangContainer: false})
        }
    }

    showLangContainer = () => {
        if (this.state.languages.length > 1) {
            this.setState({...this.state,  showLangContainer: !this.state.showLangContainer})
        } else {
            this.setState({...this.state,  showLangContainer: false})
        }
    }

    render() {
        return(
            <div className='switcher' ref={this.setWrapperRef}>
                <Switcher lang={this.state.languages.length > 0 ? 
                    this.state.languages : []} setActiveLang={this.props.setActiveLangAction} 
                    showLangContainer={this.showLangContainer} 
                    isShow={this.state.showLangContainer} size={this.state.languages.length}/>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return {
      activeLang: store.activeLang
    }
}
  
const mapDispatchToProps = dispatch => bindActionCreators({
    setActiveLangAction,
}, dispatch)
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LangSwitchers);

LangSwitchers.propTypes = {
    setActiveLangAction: PropTypes.func.isRequired,
}